module.exports = __webpack_public_path__ + "static/media/perfil.69545e67.svg";